import { createRequestActions } from '../utils';
import * as userRoleTypes from './userRoleTypes';

export const listUserRoleForRoles = createRequestActions(userRoleTypes.USER_ROLE_LIST_FOR_ROLES, roles => ({ roles }));
